export var getRecipientName = function getRecipientName(signer) {
  if (signer.firstName && signer.lastName) {
    return "".concat(signer.firstName, " ").concat(signer.lastName);
  } else if (signer.email) {
    return signer.email;
  } else if (signer.mobile) {
    var mobile = signer.mobile;
    return "".concat(mobile.prefix).concat(mobile.number);
  }
  return null;
};
export default getRecipientName;